// $( window ).on("load", function() {
//   setTimeout(function() {
//     //alert("changed")
//     $(".metafield_video_active").prevAll(".product-gallery__thumbnail").removeClass("Featured-select");
//    $(".metafield_video_active").nextAll(".product-gallery__thumbnail").removeClass("Featured-select");
//     $(".metafield_video_active").prevAll(".product-gallery__thumbnail").removeClass("is-nav-selected");
//    $(".metafield_video_active").nextAll(".product-gallery__thumbnail").removeClass("is-nav-selected");
//   $(".metafield_video_active").addClass("is-nav-selected");
//   $(".metafield_video_right_section").prevAll(".product-gallery__image").removeClass("Featured-select");
//    $(".metafield_video_right_section").nextAll(".product-gallery__image").removeClass("Featured-select");
//     $(".metafield_video_right_section").prevAll(".product-gallery__image").removeClass("is-selected");
//    $(".metafield_video_right_section").nextAll(".product-gallery__image").removeClass("is-selected");
//     $(".product-gallery__video").show();
//   } , 2500);
// });

 var disc = $("span.discount-cde-bt-hr").text().replace("%","");
// for product page
var currency_format = $("html").attr("symbol");
  
var ret = currency_format.replace("{{amount}}",'');
 // ret = currency_format.replace("{{amount_with_comma_separator}}",'');
 console.log(ret)
if (ret == "€{{amount_with_comma_separator}}") {
  ret = currency_format.replace("{{amount_with_comma_separator}}",'');
}

// $(".c-price").text(ret1)
$(document).on('change', 'select.pplr_select', function() {
  
  var pricem = $("select.variant-selection__variants").find("option:selected").attr("price");
   var pricem1 = pricem.replace(ret,"");
  //pricem1 = pricem1.replace(",","");
    if (ret == "€") {
      pricem1 = pricem1.replace(',', '');
      pricem1 = pricem1.replace('.', '');
       }
      else if( ret == "£"){
     pricem1 = pricem1.replace(',', '');
      pricem1 = pricem1.replace('.', '');  
      }
      else{
        pricem1 = pricem1.replace(",","");
        pricem1 = pricem1.replace('.', '');
      }
  // Does some stuff and logs the event to the console
  //var val = $(this).find("option:selected").attr("data-price");
   var val = $(this).find("option:selected").attr('data-pplr_price');
   var add = parseFloat(pricem1) + parseInt(val);

  var per = (parseInt(disc)/parseInt(100))*add;
  console.log(per)
  //per = per.toFixed(2);
  var per1 = parseFloat(add) - parseFloat(per);
  
  // per1 = per1.toFixed(2);
   if (ret == "€") {
     // per1 = per1.replace('.', ',');    
     per1 =  Shopify.formatMoney(per1,"€{{amount}}");
     per1 = per1.replace('.', ',');
     }
      else if( ret == "£"){
      per1 =  Shopify.formatMoney(per1,"£{{amount}}");
      per1 = per1.replace('.', ',');
      }
     else{
      per1 =  Shopify.formatMoney(per1,"${{amount}}");
       per1 = per1.replace(',', '.');
    }

  $(".right-div").text(per1);
  //add = add.toFixed(2);
   if (ret == "€") {

   add =  Shopify.formatMoney(add,"€{{amount}}");
   }
   else if( ret == "£"){
   add =  Shopify.formatMoney(add,"£{{amount}}");
   }
   else{
     add =  Shopify.formatMoney(add,"${{amount}}");
   }
  $("span.price span.money").text(add);
  $("span.compricew-bt").text(add);
  //$(this).parents(".product-form-container").parents(".product_section").find(".product-block--price").addClass('enable_discount-cls');
  $(".right-div-discount").text(per1);

   $(".right-div-vendors").text(add);
  
});



$("document").ready(function() {   
   
  // $(".product-gallery__thumbnail").on("click", function(){
  //   var data_title = $(this).attr("data-title");
  //   console.log(data_title)
  //   $(".product-gallery__image[data-title='"+data_title+"']").parents(".product-gallery__image").addClass("is-selected")
  //   // $(".product-gallery__image img[alt='"+data_title+"']").parents(".product-gallery__image").prevAll(".product-gallery__image").removeClass("is-selected");
  //   // $(".product-gallery__image img[alt='"+data_title+"']").parents(".product-gallery__image").nextAll(".product-gallery__image").removeClass("is-selected");
  //  })
  //  $('.product-gallery__main').find('.product-gallery__image').removeClass('is-selected');
  //  $('.product-gallery__thumbnails').find('.product-gallery__thumbnail').removeClass('is-nav-selected');
  //  $('.product-gallery__main').find('.Featured-select').addClass('is-selected');
  //  $('.product-gallery__thumbnails').find('.Featured-select').addClass('is-nav-selected');

  //  setTimeout(function() { 
  //    if ( $(".product-gallery__thumbnail").hasClass("metafield_video_active") )
  //    {
  //     console.log("has video");
  //      $('.metafield_video_active').trigger('click');
  //    }
  //    else
  //    {
  //      console.log("has featured alt");
  //      $('.product-gallery__thumbnail[data-title="Featured"]').trigger('click');
       
  //    }
  //      setTimeout(function() { 
  //    $('.product-gallery__thumbnail[data-title="Featured"]').trigger('click');
  //    $('.product-gallery__main').find('.product-gallery__image').removeClass('is-selected');
  //    $('.product-gallery__thumbnails').find('.product-gallery__thumbnail').removeClass('is-nav-selected');
  //     $('.product-gallery__main').find('.Featured-select').addClass('is-selected');
  //    $('.product-gallery__thumbnails').find('.Featured-select').addClass('is-nav-selected');
  //    }, 1000);
  //  }, 1500);

  

  /* --------------------------
     Thumbnail click handler
  --------------------------- */
  $(document).on("click", ".product-gallery__thumbnail", function () {
    var data_title = $(this).attr("data-title");
    console.log("Thumbnail clicked:", data_title);

    $('.product-gallery__main')
      .find('.product-gallery__image')
      .removeClass('is-selected');

    $('.product-gallery__image[data-title="' + data_title + '"]')
      .parents(".product-gallery__image")
      .addClass("is-selected");
  });

  /* --------------------------
     ON LOAD: Conditional reset
  --------------------------- */
  setTimeout(function () {

    var hasVideo = $(".product-gallery__thumbnail").hasClass("metafield_video_active");
    var hasFeaturedMain = $('.product-gallery__main .Featured-select').length > 0;
    var hasFeaturedThumb = $('.product-gallery__thumbnails .Featured-select').length > 0;

    console.log("On load checks:", {
      hasVideo,
      hasFeaturedMain,
      hasFeaturedThumb
    });

    // Only run reset if required classes exist
    if (hasVideo || (hasFeaturedMain && hasFeaturedThumb)) {

      console.log("Running conditional class reset");

      $('.product-gallery__main')
        .find('.product-gallery__image')
        .removeClass('is-selected');

      $('.product-gallery__thumbnails')
        .find('.product-gallery__thumbnail')
        .removeClass('is-nav-selected');

      if (hasFeaturedMain) {
        $('.product-gallery__main')
          .find('.Featured-select')
          .addClass('is-selected');
      }

      if (hasFeaturedThumb) {
        $('.product-gallery__thumbnails')
          .find('.Featured-select')
          .addClass('is-nav-selected');
      }
    }

    /* --------------------------
       Auto-trigger clicks
    --------------------------- */
    if (hasVideo) {
      console.log("Auto-selecting video thumbnail");
      $('.metafield_video_active').trigger('click');
    } else if (hasFeaturedThumb) {
      console.log("Auto-selecting featured thumbnail");
      $('.product-gallery__thumbnail[data-title="Featured"]').trigger('click');
    }

  }, 1500); // wait for gallery load














  
  //$(".filter-toggle-button").siblings().css("display", "none");
  // $(".filter-toggle-button").siblings().hide();
  // $(".filter-toggle-button").click(function(){ 
  // $(".filter-toggle-button").siblings().slideToggle("fast");
  // });
  
  $(".filter-toggle-button").click(function(){    
      $('body').addClass('filter_drawer-body')
      $(".filter-toggle-button").siblings(".faceted-filter-form").addClass("filter_drawer-open");
      $(this).siblings(".faceted-filter-form").addClass("filter_drawer-open").css("display", "block");
     
  });
   $(".filter-drawer-close").click(function(){ 
      $('body').removeClass('filter_drawer-body')
      $(this).parents(".faceted-filter-form").removeClass("filter_drawer-open"); 
      $(this).parents(".faceted-filter-form").removeClass("filter_drawer-open").css("display", "none");
     
  });

      if ($(window).width() < 798) {
       $(".faceted-filter-form").addClass("filter_drawer-mobile");
       // $('.footer-block--image,.footer-block--image').wrapAll('<div class="child"></div>');
       $('.faceted-active-filters-main, .sidebar__block, .sidebar__block, .sidebar__block').wrapAll( $('<div>').addClass('wrap_mob-filter') );
      }
$("variant-selection").on("change", function(){
  var atr = $(this).attr("variant");
  var disc = $("span.discount-cde-bt-hr").text().replace("%","");
  console.log(atr);
  if(atr =="unavailable")
  {
   $(".right-div-discount").text("");
  }
 
  $("span.custo-var .v--list").each(function(){
    var id = $(this).attr("id");
    if ( id == atr )
    {
           
      var get = $(this).attr("v-price");
      get = get.replace(ret,"");
       price = get.replace(ret, "");
      // get = get.replace(",","");
      if (ret == "€") {
        price = price.replace('.', '');
        price = price.replace(',', '');
        get = get.replace('.', '');
        get = get.replace(',', '');
       }
        else if( ret == "£"){
         price = price.replace('.', '');
         price = price.replace(',', '');
         get = get.replace('.', '');
         get = get.replace(',', '');
       }
      else{
        price = price.replace('.', '');
        price = price.replace(',', '');
        get = get.replace(",","");
        get = get.replace(".","");
      }
      var len = $("select.pplr_select").length;
      if ( len > 0 )
      {
        //var findp = $("select.pplr_select").find("option:selected").attr('data-price');
        var findp = $("select.pplr_select").find("option:selected").attr('data-pplr_price');
 
      var newp = parseFloat(get) + parseInt(findp);
     
      //newp = newp.toFixed(2);
      if (ret == "€") {
     newp =  Shopify.formatMoney(newp,"€{{amount}}");
       }
       else if( ret == "£"){
       newp =  Shopify.formatMoney(newp,"£{{amount}}");
       }
      else{
         newp =  Shopify.formatMoney(newp,"${{amount}}");
       }
        

      $("span.compricew-bt").text(newp);
        $(".right-div-vendors").text(newp);
      $(" .modal_price.subtitle .price-ui span.price span.money").text(newp);
        
      }
      else
      {
      if (ret == "€") {
       get =  Shopify.formatMoney(get,"€{{amount}}");
         }
         else if( ret == "£"){
         get =  Shopify.formatMoney(get,"£{{amount}}");
         }
        else{
           get =  Shopify.formatMoney(get,"${{amount}}");
         }
        $("span.compricew-bt").text(get);
        $(".right-div-vendors").text(get);
      $(" .modal_price.subtitle .price-ui span.price span.money").text(newp);
        
      }
      // price = get.replace(ret, "");
      
      //price = price.replace(",","");
      var per = (disc/100)*price;
     // per = per.toFixed(2)     
      var per1 = parseFloat(price) - parseFloat(per);
     // per1 = per1.toFixed(2);
      if (ret == "€") {
       // per1 = per1.replace('.', ',');    
       per1 =  Shopify.formatMoney(per1,"€{{amount}}");
       per1 = per1.replace('.', ',');
         per1 = per1.replace('€0,', '€');
       }
        else if( ret == "£"){
      per1 =  Shopify.formatMoney(per1,"£{{amount}}");
       per1 = per1.replace('.', ',');
       per1 = per1.replace('£0,', '£');
        }
      else{
        per1 =  Shopify.formatMoney(per1,"${{amount}}");
        per1 = per1.replace(',', '.');
        per1 = per1.replace('$0.', '$');
      }

      console.log(ret)
      $(".right-div").text(per1);
      $(".right-div-discount").text(per1);
      //$(this).parents(".product-form-container").parents(".product_section").find(".product-block--price").addClass('enable_discount-cls');
      
      
      // $(".right-div-vendors").text("$"+price);
      
    }
    
  })
   var width = $(window).width();
          if(width < 798 )
          {
             //$("html,body").animate({scrollTop:0},'smooth');
            $('html, body').animate({
                scrollTop: $("#product-gallery-custom").offset().top -30
            }, 'smooth');
          }
      // $(window).on("load resize", function () {
      // var width = $(window).width();
      //     if(width < 798 )
      //     {
      //      //  $("html,body").animate({scrollTop:0},'smooth');
      //        $('html, body').animate({
      //           scrollTop: $("#product-gallery-custom").offset().top
      //       }, 'smooth');
      //     }
      // })
})
  var atr = $("variant-selection").attr("variant");
  var disc = $("span.discount-cde-bt-hr").text().replace("%","");

  
  $("span.custo-var .v--list").each(function(){
    var id = $(this).attr("id");
    if ( id == atr )
    {
      var get = $(this).attr("v-price");
      var gett = $(this).attr("v-price");
      price = get.replace(ret, "");
      get = get.replace(ret,"");
       if (ret == "€") {
      price = price.replace('.', '');
      price = price.replace(',', '');
      get = get.replace('.', '');
      get = get.replace(',', '');
       }
     else if( ret == "£"){
      price = price.replace('.', '');
      price = price.replace(',', '');
      get = get.replace('.', '');
      get = get.replace(',', '');        
        }
      else{
      price = price.replace(",","");
      price = price.replace(".","");
      get = get.replace('.', '');
      get = get.replace(',', '');
      }
      //var findp = $("select.pplr_select").find("option:selected").attr('data-price');
      var findp = $("select.pplr_select").find("option:selected").attr('data-pplr_price');
      var newp = parseFloat(get) + parseInt(findp);
      //newp = newp.toFixed(2);
      if (ret == "€") {
         newp =  Shopify.formatMoney(newp,"€{{amount}}");
       }
          else if( ret == "£"){
          newp =  Shopify.formatMoney(newp,"£{{amount}}");   
          }
        else{
         newp =  Shopify.formatMoney(newp,"${{amount}}");
       }
      $("span.compricew-bt").text(gett);
      $(".right-div-vendors").text(gett);
      //$(" .modal_price.subtitle .price-ui span.price span.money").text("$"+newp);
      //$("span.compricew-bt").text(get
      //price = price.replace(",","");

      if (ret == "€") {
      price = price.replace(',', '.');
       }
      else if( ret == "£"){
       price = price.replace(',', '.');   
      }
      else{
       price = price.replace(",","");
      }
      var per = (disc/100)*price;
      //per = per.toFixed(2);
      var per1 = parseFloat(price) - parseFloat(per);
     // per1 = per1.toFixed(2);
     if (ret == "€") {
       // per1 = per1.replace('.', ',');    
       per1 =  Shopify.formatMoney(per1,"€{{amount}}");
       per1 = per1.replace('.', ',');
       }
      else if( ret == "£"){
       per1 =  Shopify.formatMoney(per1,"£{{amount}}");
       per1 = per1.replace('.', ',');
      }
      else{
        per1 =  Shopify.formatMoney(per1,"${{amount}}");
        per1 = per1.replace(',', '.'); 
      }
      $(".right-div").text(per1);
      //$(this).parents(".product-form-container").parents(".product_section").find(".product-block--price").addClass('enable_discount-cls');

      $(".right-div-discount").text(per1);
      //$(".right-div-vendors").text("$"+price);
    }
  })
  // $("select.pplr_select").on("change", function(e){ 
  //   e.preventDefault();
  //   e.stopPropagation();
  //   console.log("selected");
  //   var val = $(this).find("option:selected").attr("data-price");
  //   console.log(val);
  //   var pricem = $("span.price span.money").text();
  //   pricem = pricem.replace("$","");
  //   var add = parseFloat(pricem) + parseInt(val);
  //   $("span.price span.money").text("$"+add);
  //   var per = (disc/100)*pricem;
  //     per = per.toFixed(2);
  //     var per1 = parseFloat(pricem) - parseFloat(per);
  //     per1 = per1.toFixed(2);
  //     $(".right-div").text("$"+per1);
                 
  // })
});


 $(document).ready(function() {
//   if ($(".custom-video_class").length) {
//     $('.custom-video_class').removeAttr('onclick');
//     $(".custom-video_class").get(0).play();
//     $(".custom-video_class").attr('loop','loop' );
//     $('.custom-video_class').attr("autoplay"," ");
//     $('.custom-video_class').attr('controls',false);
//     $('.custom-video_class').attr('preload','none');
//     $('.custom-video_class').attr('muted',true);
//     // console.log("atr");
//   }
   $(".plyr__video-wrapper, .custom-video_class").click(function(e) {
      e.preventDefault();
      e.stopPropagation();
    });
});

$(document).ready(checkContainerr);
function checkContainerr() {
  if($('.product-personalizer button').is(':visible')){ //if the container is visible on the page
     $(".purchase-details").hide();
  //  $(".right-div-discount").hide();
   // $(".modal_price").removeClass("enable_discount-clss");      
    }
  else {
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    $(".purchase-details").show(); 
    // $(".right-div-discount").show();
  }
}



  $(document).ready(function () { 
   var text = $(".right-div-discount").text();
   var text1 =  $(".protection_plan-price").text();
   var newText = text.replace(ret, '');
   var newText1 = text1.replace(ret, '');
   var result = parseFloat(newText) + parseFloat(newText1);
   var total = ret + result.toFixed(2) ;
   var total_product = ret + newText ;
   $('.total_product-price').html(total_product);
   var pricev = $(".price-ui").text();
    console.log(pricev)
   $('#protection_plan-checkbox').on('change', function() {
   if ($(this).prop('checked')) { 
   var text = $(".right-div-discount").text();
   var text1 =  $(".protection_plan-price").text();
   var newText = text.replace(ret, '');
   var newText1 = text1.replace(ret, '');
   var result = parseFloat(newText) + parseFloat(newText1);    
   var total = ret + result.toFixed(2) ;
   var total_product = ret + newText ;
   var pricev = $(".price-ui").text();
   var newTextvv = pricev.replace(ret, '');
   var newTextvv11 = newTextvv.replace(",", '');
   var resultvv = parseFloat(newTextvv11) + parseFloat(newText1);
   var totalvv = ret + resultvv.toFixed(2) ;
   // alert(resultvv)

    $(".right-div-vendors").html(totalvv)
     
    $(".protection_plan_add_btn").show();
    $(".protection_plan-desc").slideToggle();
    $('.total_product-price').html(total);
     $(".right-div").html(total)
     $(".product_forn-submit-btn").addClass("p_plan_product_s");
     $(".More-Details-heading").addClass("heading_detail"); 
    // $("#product_forn-submit-btn").hide();
  
  } else {
    var text = $(".right-div-discount").text();
    var pricev = $(".price-ui").text();
    $(".right-div-vendors").html(pricev)
    $(".product_forn-submit-btn").removeClass("p_plan_product_s");
    $(".product_forn-submit-btn").show();
    $(".protection_plan_add_btn").hide();
    $(".protection_plan-desc").slideUp();
    $(".right-div").html(text);
    $('.total_product-price').html(total_product); 
    $(".More-Details-heading").removeClass("heading_detail"); 
  }
 });
  $(".protection_plan_add_btn").click(function(){
  var arr1=[];
   $(".pplr-wrapper").each(function(){
    console.log("each working")
    // $(this).hasClass("pplr-dropdown ")    
    if($(this).hasClass("pplr-dropdown")){
    var select_dropdown  = $(this).find("select").val(); 
     console.log(select_dropdown)
    if(select_dropdown != "" && select_dropdown != "undefined"){
    arr1.push(select_dropdown);
   }
 }
   else if($(this).hasClass("pplr-text")){
   var input_value = $(this).find("input").val();
    if(input_value != "" && input_value != "undefined"){
    arr1.push(input_value);
      }
    }
  });
  var arr_length = arr1.length;
  var wrapper_lenth = $(".pplr-wrapper").length;
  if(arr_length == wrapper_lenth){
  // if ( $('.pplr_select ').val() != '' ) {
     var p_plan_id = $(".gift-product").val(); 
     var p_plan_q = 1; 
         $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {id:p_plan_id, quantity:p_plan_q},
        async:false,
        success:function () { 
        $("#product_forn-submit-btn").trigger("click")
        },
        error:function(){
        console.log("failed")
        }
      }); 
    }
  });
}); 

//////////////// shipping protection code start/////////////////////////

// $(document).ready(function(){
  
//   function shipping_protection(){  
//    var newText = $(".shipping-price-main").attr("data-ctp");
//    var total =  $(".cart__subtotal span.money").text();

//    var new_total = total.replace(ret, '');
//     if (ret == "€") {
//       new_total = new_total.replace('.', '');
//       new_total = new_total.replace(',', '');
//     }
//     else if( ret == "£"){
//       new_total = new_total.replace('.', '');
//       new_total = new_total.replace(',', '');        
//     }
//     else{
//       new_total = new_total.replace('.', '');
//       new_total = new_total.replace(',', '');
//     }
    
//     var newTextt = parseFloat(newText);
//     var new_total = parseFloat(new_total)/parseInt(100);
//       //console.log(newTextt);
//       //console.log(new_total);

//     var pricev="";
//     if(isNaN(newTextt) || isNaN(new_total)){
//       pricev=" ";
//      }else{
//       var pricev = (new_total*newTextt)/100;
//       var pfinal = pricev.toFixed(2);
//       $("span.shipping-price").attr("data-cp", pfinal);
//       var pricefinal = ret + pricev.toFixed(2);
//       $("span.shipping-price").text(pricefinal);
//       $("span.shipping-price-orignal").text(pricefinal);
//       setTimeout(function(){
//         window.PXUTheme.currencyConverter._convertEl(document.querySelector(".shipping-price-orignal"),"USD");
//       },100);
//       // console.log(pfinal);
//       // console.log(pricefinal);
//      }
     
//   }   
//   shipping_protection();

//   // Select the node that will be observed for mutations
//   const targetNode = document.querySelector('.cart__cost-summary');
  
//   // Options for the observer (which mutations to observe)
//   const config = { attributes: true, childList: true, subtree: true };
  
//   // Callback function to execute when mutations are observed
//   const callback = (mutationList, observer) => {
//     for (const mutation of mutationList) {
//       if (mutation.type === "childList") {
//        //console.log("A child node has been added or removed.");
//          shipping_protection();
//       } 
//       else if (mutation.type === "attributes") {
//         //console.log(`The ${mutation.attributeName} attribute was modified.`);
//       }
//     }
//   };
  
//   // Create an observer instance linked to the callback function
//   const observer = new MutationObserver(callback);
  
//   // Start observing the target node for configured mutations
//   observer.observe(targetNode, config);
  
//   // Later, you can stop observing
//   // observer.disconnect();

  
// ////////////////////// code for  shipping-price-orignal div ///////////////////////////////
  
//   //  // Select the node that will be observed for mutations
//   // const targetNodee = document.querySelector('.cart__checkout-container');
  
//   // // Options for the observer (which mutations to observe)
//   // const configg = { attributes: true, childList: true, subtree: true };
  
//   // // Callback function to execute when mutations are observed
//   // const callbackk = (mutationList, observerr) => {
//   //   for (const mutation of mutationList) {
//   //     if (mutation.type === "childList") {
//   //      //console.log("A child node has been added or removed.");
//   //        shipping_protection();
//   //     } 
//   //     else if (mutation.type === "attributes") {
//   //       //console.log(`The ${mutation.attributeName} attribute was modified.`);
//   //       //window.PXUTheme.currencyConverter._convertEl(document.querySelector(".shipping-price-orignal"),"USD");
//   //     }
//   //   }
//   // };
  
//   // // Create an observer instance linked to the callback function
//   // const observerr = new MutationObserver(callbackk);
  
//   // // Start observing the target node for configured mutations
//   // observerr.observe(targetNodee, configg);
  
//   // // Later, you can stop observing
//   // // observer.disconnect();
  
//     $('input#shipping-protection-checkbox').on('change', function() {
//       if ($(this).prop('checked')) { 
//          $(this).parents('.shipping-checkbox-main').addClass("active");
  
//        }else
//       {
//         $(this).parents('.shipping-checkbox-main').removeClass("active");
//       }
//      });

//   $('.cart__checkout button.checkout').on('click',async function(e) { 
//     e.preventDefault();
//     e.stopPropagation();
//       if ($('#shipping-protection-checkbox').prop('checked')) { 
//          //console.log("checked");
//         var product_price = $("span.shipping-price").attr("data-cp"); 
       
//         //var product_price = $("span.shipping-price-orignal").attr("data-currency-usd");
//         var product_title = $(".custom_shipping-prd-title").val();
//         var product_tag = $(".custom_shipping-prd-tag").val();
//         var image_src = $(".custom_shipping-prd-image").val();
        
//         //var api_url = 'https://upbrighters.com/monogram-hub/api/index.php?title='+product_title+'&tags='+product_tag+'&price='+product_price+'&images='+image_src+'&published_scope=global';
//         var api_url = 'https://mhshipprotection.com/monogram-hub/index.php?title='+product_title+'&tags='+product_tag+'&price='+product_price+'&images='+image_src+'&published_scope=global';
          
//         console.log(api_url);
        
//         //   $.ajax({
//         //     url: api_url,
//         //     type: "POST",
//         //      headers: {
//         //      "Access-Control-Allow-Origin": "*"
//         //     },
//         //     dataType: "json",
//         //     crossDomain: true,
//         //     success:function(json){
//         //         console.log('message: ' + "success"+ JSON.stringify(json));   

//         //         //  $.ajax({
//         //         //   type:"POST",
//         //         //   url:"/cart/add.js",
//         //         //   data:"quantity=1&id=",
//         //         //   dataType:"json",
//         //         //   success: function(atc_data){
//         //         //   console.log(atc_add);
//         //         //   }
//         //         // })
//         //     },
//         //     error:function(error){
//         //         console.log('message Error' + JSON.stringify(error));
//         //     }  
//         // });  
        
//         //  $.ajax({
//         //   type:'POST',
//         //   url:api_url,
//         //   dataType:'json',
//         //   success:function(data){
//         //   console.log(data);
         
//         //     // $.ajax({
//         //     //   type:"POST",
//         //     //   url:"/cart/add.js",
//         //     //   data:"quantity=1&id="+added_produc,
//         //     //   dataType:"json",
//         //     //   success: function(cart_add){
//         //     //   console.log(cart_add);
             
//         //     //   }
//         //     // });
//         //   },
//         //     error:function(error){
//         //         console.log('message Error');
//         //     } 
//         // });
   
//         const response = await fetch(api_url);
//         const data = await response.json();
//         console.log(data);
//         var p_variant = data.variants[0].id;
//         console.log(p_variant);
//          //setTimeout(function(){  
//           $.ajax({
//             type:"POST",
//             url:"/cart/add.js",
//             data:"quantity=1&id="+p_variant,
//             dataType:"json",
//             success: function(cart_add){
//             console.log(cart_add);
           
//               window.location = "/checkout";
           
//             },
//               error:function(error){
//               console.log('message Error');
//             } 
//           });
//          // },30000);
//        }else
//       {
//        // console.log("not checked");
//         window.location = "/checkout";
//       }
//   });
    
//   $(".cart__item-list .cart__card").each(function(){ 
//     if ($(this).attr('data-item-tag') != undefined) {
//        //console.log($(this).attr('data-item-tag'));
//       $(this).find(".cart__remove").find("a.cart__remove-btn").trigger('click');
//     }
//   });  
// });

//////////////// shipping protection code start/////////////////////////
var shipping_check = $(".shipping_check_input").val(); 
console.log(shipping_check);
if (shipping_check == "true") {
$(document).ready(function(){

 $(".cart__item-list .cart__card").each(function(){ 
    if ($(this).attr('data-item-tag') != undefined) {
       console.log($(this).attr('data-item-tag'));
      $(this).find(".cart__remove").find("a.cart__remove-btn").trigger('click');
    }
  }); 
  
  var currencyFormat = window.PXUTheme.currency.symbol;
  var prcformat = $("body").attr("price-format");
  // console.log("currencyFormat"+currencyFormat);
  //console.log("prcformat"+prcformat);
  
  
  function shipping_protection(){

   var newText = $(".shipping-price-main").attr("data-ctp");
   var total =  $(".cart__subtotal span.money").text();
  if (!$(".docapp-in-summary").hasClass("active_custom")) {
   var new_total = total.replace(ret, '');
    if (ret == "€") {
      new_total = new_total.replace('.', '');
      new_total = new_total.replace(',', '');
    }
    else if( ret == "£"){
      new_total = new_total.replace('.', '');
      new_total = new_total.replace(',', '');        
    }
    else{
      new_total = new_total.replace('.', '');
      new_total = new_total.replace(',', '');
    }
    
    var newTextt = parseFloat(newText);
    var new_total = parseFloat(new_total)/parseInt(100);
      console.log(newTextt);
      console.log("new total "+new_total);

    var pricev="";
    if(isNaN(newTextt) || isNaN(new_total)){
      pricev=" ";
     }else{
      var pricev = (new_total*newTextt)/100;
      
      var pfinal = pricev.toFixed(2);
      $("span.shipping-price").attr("data-cp", pfinal);
      //var pricefinal = ret + pricev.toFixed(2);

      //code for multiple conditions 
      var ctprd_mincharg = $(".custom-protection-mincharge").val(); 
      console.log(pfinal);    
      console.log(ctprd_mincharg);
      
        var npfinal="";
           if(  parseFloat(pfinal) <=  parseFloat(ctprd_mincharg) ){
            npfinal = $(".custom-protection-mincharge").val(); 
            console.log(npfinal);
          }else
          {
            var arr1=[];
            $(".cart__item-list .cart__card").each(function(){ 
              if ($(this).attr('data-item-vendor') != undefined) {
                console.log($(this).attr('data-item-vendor'));
                var npfinal = $(".custom-protection-vendor").val(); 
                console.log(npfinal);
                arr1.push(npfinal); 
              }             
            }); 
    
            var arr_length = arr1.length;
      
            if(arr_length != 0){
             console.log($(this).attr('data-item-vendor'));
                var npfinal = $(".custom-protection-vendor").val(); 
                console.log(npfinal);

              }
              else
              {
                if( pfinal <= ctprd_mincharg ){
                  npfinal = $(".custom-protection-mincharge").val(); 
                  console.log(npfinal);
                }else
                {
               console.log("note vandor");
                 var npfinal = $("span.shipping-price").attr("data-cp"); 
                 console.log(npfinal);
   
              }
            } 
         }

       $("span.shipping-price").attr("data-cp", npfinal);
      
      //old variable for shipping price
      //var pricefinal = pricev.toFixed(2);
     var pricefinal = npfinal;
     if ( prcformat == "non-decimal" )
      {
        $("span.shipping-price-orignal").text(Shopify.formatMoney(pricefinal, currencyFormat+"{{amount_no_decimals}}"));
        $("span.shipping-price").text(Shopify.formatMoney(pricefinal, currencyFormat+"{{amount_no_decimals}}"));
         //console.log(Shopify.formatMoney(pricefinal, currencyFormat+"{{amount_no_decimals}}"));
      }
      else
      {
        $("span.shipping-price-orignal").text(Shopify.formatMoney(pricefinal, currencyFormat+"{{amount}}"));
        $("span.shipping-price").text(Shopify.formatMoney(pricefinal, currencyFormat+"{{amount}}"));
       //console.log(Shopify.formatMoney(pricefinal, currencyFormat+"{{amount}}"));
      }
      
      // $("span.shipping-price").text(pricefinal);
      // $("span.shipping-price-orignal").text(pricefinal);
      
        window.PXUTheme.currencyConverter._convertEl(document.querySelector(".shipping-price-orignal"),"USD");
      
      //new code for updating cart subtotal
       if($(".docapp-in-summary").length != 0)
        {
           var orgPrice = $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right span.money").attr("data-geolizr-price");
           var minsPrice = $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-discount .docapp-right span.money").attr("data-geolizr-price");
           var orgEsTPrice = $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").attr("data-geolizr-price");
          //console.log("orgTPrice "+orgTPrice);
          // console.log("orgEsTPrice "+orgEsTPrice);


          
          var orgTPriceF =  parseFloat(orgPrice);
           var orgEsTPriceF = parseFloat(orgPrice) - parseFloat(minsPrice);

          
         // console.log("orgTPriceF"+ orgTPriceF);
          //console.log("orgEsTPriceF" + orgEsTPriceF);
          
           var sPrice = $("span.shipping-price").attr("data-cp");
           // console.log(orgPrice);
           // console.log(sPrice);
           // console.log(minsPrice);
        
           var orgPrice = parseFloat(orgPrice)/parseInt(100);
           var minsPrice = parseFloat(minsPrice)/parseInt(100);
          var orgEsTPrice = parseFloat(orgEsTPrice)/parseInt(100);
          
           var sbTotal =  parseFloat(orgPrice) + parseFloat(sPrice);
           //console.log(sbTotal);
           var estTotal = parseFloat(sbTotal) - parseFloat(minsPrice);
            //console.log(estTotal);
           var final_oPrice = sbTotal.toFixed(2);
           var final_estPrice = estTotal.toFixed(2);

           // var orgTPriceF =  parseFloat(orgPrice) - parseFloat(sPrice);
           // var orgEsTPriceF = parseFloat(orgEsTPrice) - parseFloat(sPrice);

           if ( $('input#shipping-protection-checkbox').prop('checked')) {  
            // console.log("checked");
             if (!$(".docapp-in-summary").hasClass("active_custom")) {
                if ( prcformat == "non-decimal" )
                  {
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right .money").text(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount_no_decimals}}"));
                   // console.log(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount_no_decimals}}"));
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").text(Shopify.formatMoney(final_estPrice, currencyFormat+"{{amount_no_decimals}}"));
                    $(".docapp-in-summary").addClass("active_custom");  
                    
                  }
                  else
                  {
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right .money").text(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount}}"));
                   // console.log(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount}}"));
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").text(Shopify.formatMoney(final_estPrice, currencyFormat+"{{amount}}"));
                    $(".docapp-in-summary").addClass("active_custom");   
                  }  
               }
            }
          
         
          $('input#shipping-protection-checkbox').on('change', function() {
            if ($(this).prop('checked')) {  
             //console.log("checked");
           
                if ( prcformat == "non-decimal" )
                  {
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right .money").text(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount_no_decimals}}"));
                    //console.log(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount_no_decimals}}"));
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").text(Shopify.formatMoney(final_estPrice, currencyFormat+"{{amount_no_decimals}}"));
                   // $(".docapp-in-summary").addClass("active_custom");  
                    
                  }
                  else
                  {
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right .money").text(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount}}"));
                   // console.log(Shopify.formatMoney(final_oPrice, currencyFormat+"{{amount}}"));
                    $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").text(Shopify.formatMoney(final_estPrice, currencyFormat+"{{amount}}"));
                   // $(".docapp-in-summary").addClass("active_custom");   
                  }  
              
            }else
            {
              
              //console.log("else checked");
              if ( prcformat == "non-decimal" )
               {
                  $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right .money").text( Shopify.formatMoney(orgTPriceF, currencyFormat+"{{amount_no_decimals}}"));
                   // console.log("change else checked oprice"+ orgTPriceF);
                  $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").text( Shopify.formatMoney(orgEsTPriceF, currencyFormat+"{{amount_no_decimals}}"));
                      
                }
                else
                {
                   $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-cart-subtotal .docapp-right .money").text( Shopify.formatMoney(orgTPriceF, currencyFormat+"{{amount}}"));
                  //  console.log("change else checked oprice"+ orgTPriceF);
                   $(".docapp-cart-with-coupon-summary .docapp-cart-item.docapp-est-total .docapp-right span.money").text( Shopify.formatMoney(orgEsTPriceF, currencyFormat+"{{amount}}"));
                 
                }   
            }
          });
       }
     }
    }
  }   
  
  shipping_protection();

  // Select the node that will be observed for mutations
  const targetNode = document.querySelector('.cart__cost-summary');
  
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
       //console.log("A child node has been added or removed.");
         shipping_protection();
      } 
      else if (mutation.type === "attributes") {
        //console.log(`The ${mutation.attributeName} attribute was modified.`);
      }
    }
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
  
  // Later, you can stop observing
  // observer.disconnect();
  
    $('input#shipping-protection-checkbox').on('change', function() {
      if ($(this).prop('checked')) { 
         $(this).parents('.shipping-checkbox-main').addClass("active");
  
       }else
      {
        $(this).parents('.shipping-checkbox-main').removeClass("active");
      }
     });

  $('.cart__checkout button.checkout').on('click', function(e) { 
    e.preventDefault();
    e.stopPropagation();
      var _this = $(this);

      _this.attr("disabled","disabled");

      $(".cart__checkout").find(".button-checkout-inner").addClass("hidden");
      $(".cart__checkout").find(".loading-overlay__spinner").removeClass("hidden");
      setTimeout(function(){
        if ($('#shipping-protection-checkbox').prop('checked')) { 
          $(this).attr("disabled","disabled");
           //console.log("checked");
           var ctprd_mincharg = $(".custom-protection-mincharge").val(); 
           console.log(ctprd_mincharg);
           var ctprd_price = $("span.shipping-price").attr("data-cp"); 
           console.log(ctprd_price);
           var prod_price = $(".package-protection-product").find(".prd-variant").attr("data-prc");
           var prd_price = prod_price.replace(ret, '');
            if (ret == "€") {
              prd_price = prd_price.replace('.', '');
              prd_price = prd_price.replace(',', '');
            }
            else if( ret == "£"){
              prd_price = prd_price.replace('.', '');
              prd_price = prd_price.replace(',', '');        
            }
            else{
              prd_price = prd_price.replace('.', '');
              prd_price = prd_price.replace(',', '');
            }
    
          var newprd_price = parseFloat(prd_price)/parseInt(100);
          console.log(newprd_price);
  
          var prd_variant = $(".package-protection-product").find(".prd-variant").attr("id");
            // var prd_quanity="";
            // if( ctprd_price <= ctprd_mincharg ){
            //   // var ctprd_price = $(".custom-protection-vendor").val(); 
            //   // console.log(ctprd_price);
            //   alert(ctprd_mincharg);
            //   console.log(ctprd_price);
            //   prd_quanity = ctprd_mincharg/newprd_price;
            //   prd_quanity = Math.round(prd_quanity);
            //   console.log(prd_variant);
            //   console.log(prd_quanity);
            //  // alert(prd_quanity);
            //   $(".cart__checkout").find(".button-checkout-inner").addClass("hidden");
            //   $(".cart__checkout").find(".loading-overlay__spinner").removeClass("hidden");
            // }else
            // {
            //   var arr1=[];
            //   $(".cart__item-list .cart__card").each(function(){ 
            //     if ($(this).attr('data-item-vendor') != undefined) {
            //       console.log($(this).attr('data-item-vendor'));
            //       var ctprd_vendor = $(".custom-protection-vendor").val(); 
            //       console.log(ctprd_vendor);
            //       arr1.push(ctprd_vendor); 
            //     }             
            //   }); 
      
            //   var arr_length = arr1.length;
        
            //   if(arr_length != 0){
            //    console.log($(this).attr('data-item-vendor'));
            //       var ctprd_vendor = $(".custom-protection-vendor").val(); 
            //       console.log(ctprd_vendor);
            //       prd_quanity = ctprd_vendor/newprd_price;
            //       prd_quanity = Math.round(prd_quanity);
            //       console.log(prd_variant);
            //       console.log(prd_quanity);
            //        //alert(prd_quanity);
            //       $(".cart__checkout").find(".button-checkout-inner").addClass("hidden");
            //       $(".cart__checkout").find(".loading-overlay__spinner").removeClass("hidden");
            //   }
            //   else
            //   {
            //    console.log("note vandor");
            //      var ctprd_price = $("span.shipping-price").attr("data-cp"); 
            //      console.log(ctprd_price);
            //      prd_quanity = ctprd_price/newprd_price;
            //      prd_quanity = Math.round(prd_quanity);
            //      console.log(prd_variant);
            //      console.log(prd_quanity);
            //      //alert(prd_quanity);
            //      $(".cart__checkout").find(".button-checkout-inner").addClass("hidden");
            //      $(".cart__checkout").find(".loading-overlay__spinner").removeClass("hidden");   
            //   }
            //  }
            var prd_quanity = ctprd_price/newprd_price;
          prd_quanity = Math.round(prd_quanity);
            console.log(prd_variant);
            console.log(prd_quanity);
          $(".cart__checkout").find(".button-checkout-inner").addClass("hidden");
          $(".cart__checkout").find(".loading-overlay__spinner").removeClass("hidden");
  
          var prd_variant = $(".package-protection-product").find(".prd-variant").attr("id");  
          $.ajax({
              type:"POST",
              url:"/cart/change.js",
              data:"quantity=0&id="+prd_variant,
              async:false,
              dataType:"json",
              cache: false,
              success: function(success){
              
      
              },
                error:function(error){
                
                console.log('message Error');
              } 
          });
  
              $.ajax({
                type:"POST",
                url:"/cart/add.js",
                data:"quantity="+prd_quanity+"&id="+prd_variant,
                dataType:"json",
                success: function(success){
                _this.removeAttr("disabled");
                $(".cart__checkout").find(".button-checkout-inner").removeClass("hidden");
                $(".cart__checkout").find(".loading-overlay__spinner").addClass("hidden");
                if (discountNinja) {
                    // Check if a Discount Ninja offer is applied to the cart        
                    discountNinja.Checkout.Shopify.requiresAdvancedCheckout().then(function(requiresAdvancedCheckout) {
                      if (requiresAdvancedCheckout === true) {
                        // DN needs to handle the checkout
                        document.dispatchEvent(new CustomEvent('limoniapps:discountninja:checkout:initiate'));
                      }
                      else {
                        window.location.href = "/checkout";
                      }
                    }); 
                }
                else {
                  window.location.href = "/checkout";
                }
        
                },
                  error:function(error){
                  console.log('message Error');
                } 
              });
        }else
        {
         // console.log("not checked");
          _this.attr("disabled","disabled");
          var prd_variant = $(".package-protection-product").find(".prd-variant").attr("id");
          $(".cart__checkout").find(".button-checkout-inner").addClass("hidden");
          $(".cart__checkout").find(".loading-overlay__spinner").removeClass("hidden");
          $.ajax({
                type:"POST",
                url:"/cart/change.js",
                data:"quantity=0&id="+prd_variant,
                dataType:"json",
                cache: false,
                success: function(success){
                _this.removeAttr("disabled");
                $(".cart__checkout").find(".button-checkout-inner").removeClass("hidden");
                $(".cart__checkout").find(".loading-overlay__spinner").addClass("hidden");
                window.location = "/checkout";
        
                },
                  error:function(error){
                  $(".cart__checkout").find(".button-checkout-inner").removeClass("hidden");
                  $(".cart__checkout").find(".loading-overlay__spinner").addClass("hidden");
                  window.location = "/checkout";
                  //console.log('message Error');
                } 
              });
         // window.location = "/checkout";
        }
      },10);
      
  });  
});

}

$(window).on('load', function(){ 
 //console.log("disable");
 // executes when complete page is fully loaded, including all frames, objects and images
 $(".cart__checkout button.checkout").prop("disabled", false);
});